import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { parse, format, AsYouType } from 'libphonenumber-js';
import {EventsService} from 'angular4-events';
declare var Nanobar: any;

declare var $: any;
declare var google: any;
declare var toastr: any;

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.css']
})
export class VendorComponent implements OnInit {
nao = new Nanobar();
  vendorData: any;
  paginatedData: any;
  rejectId: any;
  page = 0;
  last_page: any;
  once = false;
  paging_once = false;
  paging = false;
  pushReceive: any;
  limit: any;
  acceptId: any;
  btnShowAfterLoad = false;
  searchCategory = '';
  clearTimeout: any;
  filterValue = 'All';
  filterValCount = 0;
  noDataFoundSearch = false;
  type = 'data';
  defaultViewToShow = false;
  productName: any;
  typeData: any;
  catAddError: any;
  description = '';
  removeSuccess: any;
  removeMsg: any;
  productTypeId: any;
  removeProductTypeNameConfirm: any;
  editVendorName: any;
  editDescription: any;
  editSuccess: any;
  editid: any;
  vndorEditMessage: any;
  disableClick: any;
  constructor(private dataService: DataService,  private pubsub: EventsService) {
    this.dataService.pageName = 'Category listing';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
  }
  clearSearch() {
    this.searchCategory = '';
    this.filterSearch();
  }

  vendorlist() {
    this.nao.go(30);
    this.noDataFoundSearch = false;
    this.btnShowAfterLoad = false;
    this.type = 'data';
    this.vendorData = [];
    console.log('login data');
    this.dataService.getVendorList(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        console.log('customer data', data);
        this.vendorData = data;
        if (this.vendorData.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.vendorData.rest_error_code === 2) toastr.error('Please login again');
        if (this.vendorData.rest_error_code === 4) toastr.error('Doest not exist');
        this.limit = 2;
        this.last_page = this.vendorData.last_page;
        this.page++;
        this.vendorData = this.vendorData.items;
        if (this.vendorData.length === 0) {
            this.defaultViewToShow = true;
        }
        this.btnShowAfterLoad = true;
         for (var i = 0; i < this.vendorData.length; i++) {
           if (this.vendorData[i].is_featured === false) {
            $( '#chkedMain' ).on( 'load', function() {
              $('#feature' + i).prop('checked', true);
            });
          }
          if (this.vendorData[i].country_code === '+1') {
          this.vendorData[i].phone_number = format(this.vendorData[i].phone_number, 'US', 'NATIONAL');
          console.log('this.vendorData[i].number', this.vendorData[i].phone_number);
          }
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  acceptVendorFunction(id) {
    this.disableClick = true;
    this.nao.go(30);
    console.log('login data');
    this.dataService.acceptVendor(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        // this.vendorlist();
        for(var i = 0; i < this.vendorData.length; i++){
          if(id === this.vendorData[i].id){
            this.vendorData[i].status = 1;
          }
        }
        this.disableClick = false;
        $('#acceptVendorPop').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        this.disableClick = false;
        console.log('error', error);
      }
    );
  }
  acceptVendorPopOpen(id) {
    this.acceptId = id;
    $('#acceptVendorPop').modal('show');
  }
  rejectVendorPopOpen(id) {
    this.rejectId = id;
    $('#rejectVendorPop').modal('show');
  }
  rejectVendorFunction (id) {
    this.disableClick = true;
    this.nao.go(30);
    console.log('login data');
    this.dataService.rejectVendor(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        // this.vendorlist();
        for(var i = 0; i < this.vendorData.length; i++){
          if(id === this.vendorData[i].id){
            this.vendorData[i].status = 2;
          }
        }
        $('#rejectVendorPop').modal('hide');
        this.disableClick = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
        this.disableClick = false;
      }
    );
  }
  getVendorListByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getVendorListPage(window.localStorage.getItem('token'), this.page).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedData = data;
        // this.limit = this.paginatedData.limit;
        this.last_page = this.paginatedData.last_page;
        this.paginatedData = this.paginatedData.items;
        for (var i = 0; i < this.paginatedData.length; i++) {
          if (this.paginatedData[i].country_code === '+1') {
          this.paginatedData[i].phone_number = format(this.paginatedData[i].phone_number, 'US', 'NATIONAL');
          console.log('this.vendorData[i].number', this.paginatedData[i].phone_number);
          }
        }
        console.log('paginated before concat data', this.paginatedData);
        this.page++;
        // this.paging = false;
        // this.once = false;
        // this.paging_once = false;
        for (var i = 0; i < this.paginatedData.length; i++) {
          this.vendorData.push(this.paginatedData[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  //  filterValUpdate(val) {
  //   this.filterValue = val;
  //   if (val === 'All') {
  //     this.filterValCount = 0;
  //     this.filterSearch();
  //   }
  //   if (val === 'Online') {
  //     this.filterValCount = 1;
  //     this.filterSearch();
  //   }
  //   if (val === 'Offline') {
  //     this.filterValCount = 2;
  //     this.filterSearch();
  //   }
  //   if (val === 'Pending') {
  //     this.filterValCount = 3;
  //     this.filterSearch();
  //   }
  //   if (val === 'Approved') {
  //     this.filterValCount = 4;
  //     this.filterSearch();
  //   }
  // }
  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
    this.type = 'search';
    this.btnShowAfterLoad = false;
    this.vendorData = [];
    this.page = 0;
    // if (this.searchCategory === '') {
    //   return;
    // }
    this.nao.go(30);
    console.log('login data');
    this.dataService.searchVendor(window.localStorage.getItem('token'), this.searchCategory).subscribe(
      (data) => {
        this.nao.go(100);
        this.vendorData = data;
        this.last_page = this.vendorData.last_page;
        this.page++;
        this.vendorData = this.vendorData.items;
        if (this.vendorData.length === 0) {
          this.noDataFoundSearch = true;
        }
        this.btnShowAfterLoad = true;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
    }, 1000);
  }
   openPop(id, name) {
    this.productTypeId = id;
    this.removeProductTypeNameConfirm = name;
    $('#productTypeRemovePop').modal('show');
  }

  editVendorPopOpen(obj) {
    console.log('obj', obj);
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    this.editVendorName = obj.name;
    this.editDescription = obj.description;
    this.editid = obj.id;
    $('#editVendorPop').modal('show');
  }
  editVendorFunction() {
    this.disableClick = true;
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    var count = 0;
    console.log('editVendorName', this.editVendorName);
    if (this.editVendorName === '' || this.editVendorName === undefined) {
        $('#editProductTypeName label').css('color', '#a10a0d');
        $('#editProductTypeName input').css('border-color', '#a10a0d');
        count++;
      }
      if (this.editDescription === '' || this.editDescription === undefined) {
        $('#editDescription label').css('color', '#a10a0d');
        $('#editDescription textarea').css('border-color', '#a10a0d');
        count++;
      }
      if (count > 0) {
      this.disableClick = false;
      return;
      }
    this.dataService.editVendor(window.localStorage.getItem('token'), this.editVendorName, this.editDescription, this.editid).subscribe(
      (data) => {
        this.editSuccess = data;
        this.vndorEditMessage = data;
        this.vndorEditMessage = this.vndorEditMessage.message;
        if (this.editSuccess.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.editSuccess.rest_error_code === 2) toastr.error('Please login again');
        if (this.editSuccess.rest_error_code === 4) toastr.error('Doest not exist');
        this.editSuccess = this.editSuccess.success;
        if (this.editSuccess === true) {
          // this.vendorlist();
          for(var i = 0; i < this.vendorData.length; i ++){
            if(this.editid === this.vendorData[i].id){
              this.vendorData[i].name = this.editVendorName;
              this.vendorData[i].description = this.editDescription;
            }
          }
          
          $('#editVendorPop').modal('hide');
          toastr.success('Vendor updated successfully');
        }
        if (this.editSuccess === false) {
          toastr.error(this.vndorEditMessage);
        }
        this.disableClick = false;
      },
      (error) => {
        console.log('error', error);
        this.disableClick = false;
      }
    );
  }
  openpAddTypePop() {
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    this.productName = '';
    this.description = '';
    $('#addProductTypePop').modal('show');
  }
  addProductTypeFunction() {
    this.disableClick = true;
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    var count = 0;
    if (this.productName === '' || this.productName === undefined) {
      $('#productTypeName label').css('color', '#a10a0d');
      $('#productTypeName input').css('border-color', '#a10a0d');
      count++;
    }
    if (this.description === '' || this.description === undefined) {
      $('#description label').css('color', '#a10a0d');
      $('#description textarea').css('border-color', '#a10a0d');
      count++;
    }
    if (count > 0) {
      this.disableClick = false;
      return;
    }
    this.dataService.addVendor(window.localStorage.getItem('token'), this.productName, this.description).subscribe(
      (data) => {
        this.typeData = data;
        this.catAddError = data;
        this.catAddError = this.catAddError.message;
        this.typeData = this.typeData.success;
        if (this.typeData === true) {
          $('#addProductTypePop').modal('hide');
          toastr.success('Vendor ' + this.productName + ' added successfully');
          this.vendorlist();
        }
        if (this.typeData === false) {
          toastr.error(this.catAddError);
        }
        this.disableClick = false;
      },
      (error) => {
        console.log('error', error);
        this.disableClick = false;
      }
    );
  }
  openPopRemove(id, name) {
    this.productTypeId = id;
    this.removeProductTypeNameConfirm = name;
    $('#productTypeRemovePop').modal('show');
  }
  removeProductTypeFunction(id) {
    this.disableClick = true;
    this.nao.go(30);
    this.dataService.removeVendor(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.removeSuccess = data;
        this.removeMsg = this.removeSuccess.message;
        this.removeSuccess = this.removeSuccess.success;
        if (this.removeSuccess === true) {
          // this.filterSearch();
          for(var i = 0; i < this.vendorData.length; i++){
            if(id === this.vendorData[i].id){
              this.vendorData.splice(i,1);
            }
          }
          $('#productTypeRemovePop').modal('hide');
          toastr.success(this.removeMsg);
        }
        if (this.removeSuccess === false) {
          toastr.error(this.removeMsg);
        }
        this.disableClick = false;
      },
      (error) => {
        this.nao.go(100);
        this.disableClick = false;
      }
    );
  }
  ngOnInit() {
    var context = this;
    this.vendorlist();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#vendors').css('color', '#d77229');
  }

}



// WEBPACK FOOTER //
// ./src/app/vendor/vendor.component.ts